module.exports = __webpack_public_path__ + "static/media/first-aid-kit-health-care.a8bf2dbf.png";